import { render, staticRenderFns } from "./monev_home.vue?vue&type=template&id=0607a41c&"
import script from "./monev_home.vue?vue&type=script&lang=js&"
export * from "./monev_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./monev_home.vue?vue&type=custom&index=0&blockType=div&class=card%20mt-3"
if (typeof block0 === 'function') block0(component)

export default component.exports